import React from "react";
import { Link } from "react-router-dom";
import { statusInfo } from "../../api/ideas";
import { HeartIcon } from "./IdeasIcons";

/**
 * Подсказка «возможно ваша идея уже есть». Не блокирует submit —
 * только предупреждает.
 */
export default function DuplicateHint({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="idz-dup">
      <div className="idz-dup-title">
        Возможно, такая идея уже есть. Поддержи её или допиши свою:
      </div>
      <ul>
        {items.map((i) => (
          <li key={i.id}>
            <Link to={`/ideas/${i.id}`} target="_blank" rel="noreferrer">
              {i.title}
            </Link>{" "}
            — <em>{statusInfo(i.status).label}</em>, <HeartIcon /> {i.likes}
          </li>
        ))}
      </ul>
    </div>
  );
}
